import React, { Component } from "react";

export default class TnC extends Component {
  render() {
    return (
      <div className="m-5">
        <h1>Terms and Conditions for Authorized Dealership Appointment</h1>
        <h2>Aitalia Coats Pvt. Ltd.</h2>
        <ol>
          <li>
            Your appointment is effective immediately and shall remain valid
            unless terminated or modified in accordance with mutually agreed
            terms, provided that this agreement is not expressly revoked in
            writing by both parties.
          </li>
          <li>
            This appointment is limited solely to the sale and distribution of
            products manufactured by Aitalia Coats Pvt. Ltd. and shall not
            extend to the products of any other business unit or division of the
            Company.
          </li>
          <li>
            By virtue of this appointment, the relationship between Aitalia
            Coats Pvt. Ltd. and yourself shall be that of principal to
            principal, and the Company reserves the right to enter into similar
            agreements with other entities. You shall refrain from engaging in
            any activity that could potentially harm the reputation or interests
            of the Company.
          </li>
          <li>
            You shall purchase products from the Company in accordance with the
            Company's prescribed terms and conditions and shall resell such
            products to customers at a price not exceeding the Maximum Retail
            Price (MRP) established by the Company.
          </li>
          <li>
            You are obligated to maintain an adequate stock of the Company's
            products, ensuring that your operations are capable of meeting
            customer demands. You and your employees shall remain entirely
            responsible for compliance with all legal obligations, and such
            personnel shall not be deemed employees or representatives of the
            Company.
          </li>
          <li>
            You shall protect the goodwill and reputation of the Company and its
            products, including trademarks, logos, and intellectual property,
            and shall not engage in any conduct that could jeopardize the
            Company's reputation or its assets.
          </li>
          <li>
            You are expected to uphold the highest standards of customer
            service. Any issue that may adversely impact the Company's
            reputation should be reported immediately to the Zonal Manager.
          </li>
          <li>
            The Company reserves the right to alter its product offerings,
            either by withdrawing, removing, or adding products to its portfolio
            as required.
          </li>
          <li>
            The Company may, at its discretion, appoint additional dealers or
            distributors for the same or other products in your geographical
            area or elsewhere.
          </li>
          <li>
            The Company may, from time to time, modify the specifications and
            pricing of its products without prior notice. The price prevailing
            at the time of dispatch, as per the Company's price list, shall
            apply.
          </li>
          <li>
            All orders placed with the Company are subject to acceptance. Upon
            acceptance, the Company will arrange delivery as it deems fit,
            determining the mode of transport, schedule, and quantities. The
            Company may cancel any order, in full or in part, at its sole
            discretion, even if partially executed. Each delivery shall be
            considered a separate contract.
          </li>
          <li>
            The risk of loss, damage, or deterioration of the products will pass
            to you upon delivery. You shall bear the responsibility for any loss
            or damage arising from delayed acceptance or failure to properly
            handle the products.
          </li>
          <li>
            In the event you fail to accept delivery within a reasonable time,
            the Company reserves the right to dispose of the products at your
            cost and risk, either through public auction or private sale,
            without further notice.
          </li>
          <li>
            Payments for products must be made via cheque, demand draft, RTGS,
            or NEFT, in accordance with the Company's specified payment methods.
            Only cheques drawn on scheduled banks will be accepted.
          </li>
          <li>
            The Company acknowledges receipt of your security cheque (Cheque No.{" "}
            <i>____</i>, dated <i>____</i>, drawn on <i>____</i>). By signing
            this agreement, you authorize the Company to present this cheque in
            the event of a default or breach of any terms outlined in this
            agreement.
          </li>
          <li>
            The products remain the property of the Company until full payment
            is received. The Company retains a lien over the products or their
            value, and any other goods in your possession, until the payment is
            cleared.
          </li>
          <li>
            All transactions shall be considered cash sales. If a cheque is not
            honored within a reasonable period or is returned unpaid, you shall
            replace it with a demand draft within 7 days of notification from
            the Company. Failure to do so may result in legal action, including
            the enforcement of the lien and termination of your dealership.
          </li>
          <li>
            All other terms governing your dealership will be in accordance with
            the Company's credit policy and related terms, as applicable.
          </li>
          <li>
            In the event of non-payment within the agreed credit period, no
            further orders will be processed until full payment is made. The
            Company reserves the right to charge interest at a rate of 18% per
            annum on overdue amounts.
          </li>
          <li>
            In the event of a cheque bouncing, a debit note of Rs. 500 will be
            issued to cover "Cheque Return Charges," plus an additional 1% of
            the bounced cheque amount.
          </li>
          <li>
            The eligibility for cash discounts and credit terms is subject to
            periodic review. The Company reserves the right to adjust these
            terms based on your payment history or other changes in its
            policies, without prior notice or explanation.
          </li>
          <li>
            You may be eligible for cash discounts and credit terms, subject to
            the Company's credit policy and your payment history. These terms
            are subject to periodic review and may be modified based on your
            previous payment record and any policy changes by the Company.
          </li>
          <div class="section">
            <h2>23. Amendment of Business Policies</h2>
            <p>
              The Company reserves the right to amend its business policies,
              rules, regulations, and guidelines at its sole discretion, based
              on changes in market conditions. Any such modifications will be
              communicated to you in writing as required.
            </p>
          </div>

          <div class="section">
            <h2>24. Confidentiality Obligation</h2>
            <p>
              You agree to maintain the confidentiality of any information
              obtained during the course of this agreement, including
              operational details, technical data, customer information, and any
              other confidential data that the Company designates as such. This
              obligation shall extend to your employees and agents.
            </p>
          </div>

          <div class="section">
            <h2>25. Intellectual Property Rights</h2>
            <p>
              You acknowledge that Aitalia Coats Pvt. Ltd. holds all
              intellectual property rights related to the products, trademarks,
              logos, and any other proprietary assets it introduces into the
              market. You agree that you shall have no claim or right over the
              Company’s intellectual property other than those explicitly
              granted herein.
            </p>
          </div>

          <div class="section">
            <h2>26. Product Quality Claims</h2>
            <p>
              You shall not raise any claims regarding the quality of the
              products once they have been accepted, unless it is found that the
              products do not conform to the standards set by Aitalia Coats Pvt.
              Ltd. Any returns of products shall be governed by the Company’s
              Credit Invoice Policy, as applicable.
            </p>
          </div>

          <div class="section">
            <h2>27. Compliance with Laws</h2>
            <p>
              You shall strictly adhere to all applicable laws and regulations
              governing the operations of your business, including, but not
              limited to, employment laws and tax obligations.
            </p>
          </div>

          <div class="section">
            <h2>28. Termination of Appointment</h2>
            <p>
              The Company reserves the right to terminate your appointment under
              the following conditions:
            </p>
            <ul>
              <li>By either party with three months’ written notice.</li>
              <li>By mutual agreement of both parties.</li>
              <li>
                The Company may terminate the appointment immediately with seven
                (7) days' written notice under the following circumstances:
              </li>
              <ul>
                <li>
                  If you become bankrupt, enter liquidation, or become
                  insolvent.
                </li>
                <li>
                  If you breach any terms of this agreement and fail to rectify
                  the breach within 10 days of receiving written notice.
                </li>
                <li>
                  If your actions undermine the Company’s trust and confidence.
                </li>
                <li>
                  If there are persistent complaints regarding the quality of
                  service provided.
                </li>
                <li>
                  If your business adversely affects the Company’s reputation or
                  goodwill.
                </li>
                <li>
                  If you fail to commence the business within a specified
                  period.
                </li>
              </ul>
            </ul>
          </div>

          <div class="section">
            <h2>29. Obligations Upon Termination</h2>
            <ul>
              <li>
                You shall cease all business activities related to the Company.
              </li>
              <li>
                You shall not hold yourself out as an authorized dealer of the
                Company.
              </li>
              <li>
                You shall discontinue the use of the Company’s trademarks,
                logos, and intellectual property.
              </li>
              <li>
                You shall not disclose or use any confidential information for
                any purpose other than that agreed with the Company.
              </li>
              <li>
                You shall sign any necessary documentation to cease using the
                Company’s intellectual property.
              </li>
            </ul>
          </div>

          <div class="section">
            <h2>30. No Compensation Upon Termination</h2>
            <p>
              Upon termination or expiration of this agreement, you shall not be
              entitled to any compensation, including damages or costs, from the
              Company. The termination shall not affect any rights or
              obligations accrued prior to such termination.
            </p>
          </div>

          <div class="section">
            <h2>31. Indemnification</h2>
            <p>
              You agree to indemnify and hold the Company harmless from any
              loss, costs, damages, claims, or expenses arising from any act,
              neglect, default, or breach of this agreement by you, your agents,
              employees, licensees, or customers. This includes but is not
              limited to consumer complaints unrelated to inherent manufacturing
              defects in the Company’s products.
            </p>
          </div>

          <div class="section">
            <h2>32. Severability Clause</h2>
            <p>
              If any clause or provision of this agreement is found to be
              invalid or unenforceable, the remainder of the agreement shall
              remain in full force and effect, unless the Company reasonably
              determines that the purpose of the agreement is frustrated by such
              invalidity.
            </p>
          </div>

          <div class="section">
            <h2>33. Waiver of Rights</h2>
            <p>
              The failure of either party to enforce any provision of this
              agreement or to exercise any rights under this agreement shall not
              waive such rights in the future, and any condonation of default or
              breach shall not constitute a waiver of that right.
            </p>
          </div>

          <div class="section">
            <h2>34. Force Majeure</h2>
            <p>
              Neither party shall be held liable for delays or non-performance
              due to force majeure events. The defaulting party shall promptly
              notify the other party of the cause and take all necessary steps
              to resume compliance with this agreement.
            </p>
          </div>

          <div class="section">
            <h2>35. Notices</h2>
            <p>
              Any notice under this agreement shall be in writing and deemed
              served if delivered by hand, prepaid registered post with
              acknowledgment requested, or by courier to the address provided by
              the party concerned.
            </p>
          </div>

          <div class="section">
            <h2>36. Governing Law and Jurisdiction</h2>
            <p>
              This agreement and its terms and conditions shall be governed by
              and construed in accordance with the laws of India. Any legal
              action arising out of or in connection with this agreement shall
              be subject to the exclusive jurisdiction of the courts in Delhi.
            </p>
          </div>

          <p>
            <strong>
              By signing below, we hereby accept all the terms and conditions
              outlined above.
            </strong>
          </p>
        </ol>
      </div>
    );
  }
}
